// Constants
import { OPTIONS_STORE_CLARA } from '@/vuex/module/clara';

const ZOOM_TOKEN = '--tc-zoom';
const VIEWPORT_EVENTS = ['resize', 'scroll'];
const PANEL_RIGHT = 20;
const LAUNCHER_RIGHT = 24;
const PANEL_CLASS = { MOBILE: 'support-widget--mobile', DESKTOP: 'support-widget--desktop' };

/* O app inteiro roda com `zoom` no <html> (tokens.css); o painel e a bolinha o
   anulam e trabalham em pixels de tela. O que vem do app (a largura da Clara)
   esta na escala do zoom e precisa ser convertido. */
function pageZoom() {
  const zoom = Number.parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue(ZOOM_TOKEN));

  return zoom > 0 ? zoom : 1;
}

/**
 * Onde o painel do chat de suporte e a bolinha ficam na tela.
 *
 * Desktop: canto inferior direito, recuando quando a Clara esta aberta, para
 * nao ficar por cima dela. Celular: o painel ocupa a tela e acompanha a parte
 * visivel — com o teclado aberto ela encolhe e o navegador empurra a pagina;
 * sem acompanhar, o topo do chat sai da tela e o campo fica atras do teclado.
 *
 * O componente chama `trackVisibleArea(true)` enquanto o painel esta aberto em
 * tela pequena.
 */
const mixinSupportWidgetPlacement = {
  data() {
    return {
      visibleArea: null
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    panelClasses() {
      return this.isMobile ? PANEL_CLASS.MOBILE : PANEL_CLASS.DESKTOP;
    },

    /* Largura que a Clara ocupa, em pixels de tela. No celular ela cobre a tela
       inteira e nao ha o que recuar. */
    sideOffset() {
      const claraWidth = this.$store.getters[OPTIONS_STORE_CLARA.GETTERS.CONTENT_OFFSET];

      return this.isMobile ? 0 : Math.round(claraWidth * pageZoom());
    },

    visibleAreaStyle() {
      return this.visibleArea
        ? { top: `${this.visibleArea.top}px`, height: `${this.visibleArea.height}px`, bottom: 'auto' }
        : null;
    },

    panelStyle() {
      return this.isMobile ? this.visibleAreaStyle : this.rightOffsetStyle(PANEL_RIGHT);
    },

    launcherStyle() {
      return this.rightOffsetStyle(LAUNCHER_RIGHT);
    }
  },

  beforeDestroy() {
    this.trackVisibleArea(false);
  },

  methods: {
    rightOffsetStyle(base) {
      return this.sideOffset > 0 ? { right: `${base + this.sideOffset}px` } : null;
    },

    trackVisibleArea(isActive) {
      const viewport = window.visualViewport;

      if (!viewport) return;

      VIEWPORT_EVENTS.forEach((eventName) => viewport.removeEventListener(eventName, this.readVisibleArea));
      this.visibleArea = null;

      if (!isActive) return;

      VIEWPORT_EVENTS.forEach((eventName) => viewport.addEventListener(eventName, this.readVisibleArea));
      this.readVisibleArea();
    },

    readVisibleArea() {
      const viewport = window.visualViewport;

      this.visibleArea = {
        top: Math.round(viewport.offsetTop),
        height: Math.round(viewport.height)
      };
    }
  }
};

export default mixinSupportWidgetPlacement;
